mutation SyncIntegrationMembers(
  $audienceId: ID!
  $integrationId: ID!
  $listIds: [String],
  $listType: ListType!,
) {
  syncIntegrationMembers(
    audienceId: $audienceId
    integrationId: $integrationId
    listIds: $listIds
    listType: $listType
  ) {
    displayName
    jobRunId
    status
  }
}
